import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Social Media Wall",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-social-media-wall",
    args: {
        loadMoreText: "Load more",
        noMorePostsText: "There are no more posts to be shown",
        wallIdentifier: "w76gb",
    },
    argTypes: {
        loadMoreText: {
            control: "string",
        },
        noMorePostsText: {
            control: "string",
        },
        wallIdentifier: {
            control: "string",
        },
    },
};

const Template = ({ loadMoreText, noMorePostsText, wallIdentifier }) => html`
    <ux-iws-social-media-wall
        load-more-text="${loadMoreText}"
        no-more-posts-text="${noMorePostsText}"
        wall-identifier="${wallIdentifier}"
    >
        <ux-icon name="tiles-big"></ux-icon>
        <p class="ux-text-normal">
            Please accept the cookies to view the posts
        </p>
    </ux-iws-social-media-wall>
    <button
        onclick="document.dispatchEvent(new CustomEvent('uxLegacyCookiesAccepted', {bubbles: true}))"
        class="ux-button ux-u-mx-xs"
    >
        Accept Cookie
    </button>
`;

export const Default = Template.bind({});
Default.args = {
    loadMoreText: "Load more",
    noMorePostsText: "There are no more posts to be shown",
    wallIdentifier: "w76gb",
};
